import { CommonDialogs } from "../../CommonDialogs";
import { MenuBranchSelector } from "../MenuBranchSelector";
import { MenuEditorTreeNode } from "../MenuEditorTreeNode";
import { MenuAction } from "./MenuAction";

export class MenuActionMove extends MenuAction {

    async internalExecute(): Promise<boolean> {
        let deleteParent: boolean = false;
        if (this.node.isOnlyChild()) {
            if (!await this.promptIfOnlyChild()) {
                return false;
            }
            deleteParent = true;
        }

        const newParent = await new MenuBranchSelector({ excludedNode: this.node }).show();
        if (newParent == null) {
            return false;
        }
        this.moveNodeToParent(newParent);
        if (deleteParent) {
            this.deleteParentItem();
        }
        this.menuItemToSelect = this.node.menuItem;
        return true;
    }

    private async promptIfOnlyChild() {
        if (this.node.isOnlyChild()) {
            const msg = "Moving this item will delete the parent submenu. Continue?";
            return await CommonDialogs.showDestructive(msg);
        }
        return false;
    }

    private moveNodeToParent(newParent: MenuEditorTreeNode) {
        this.parentNode.menuItem?.removeChild(this.node.menuItem);
        const updateGroupReference = this.node.menuItem.isSharedMenuReference();
        newParent.menuItem.addChild(this.node.menuItem, updateGroupReference);
    }

    private deleteParentItem() {
        const groupId = this.parentNode.menuItem.groupData.get("id");
        const rootMenuData = this.node.tree.menuData;
        const itemsToDelete = rootMenuData.getRecursiveItems(item => item.groupData.get("id") === groupId && item.parent !== null);
        for (const item of itemsToDelete) {
            item.parent.removeChild(item);
            this.menuDataSource.deleteMenuItem(item);
        }
    }
}
